module.exports = __webpack_public_path__ + "static/media/Umm-Al-Quwain2.151dcbff.jpg";